import { observer } from 'mobx-react'
import React from 'react'
import BZRXCommonCompensation from '../BZRXCommonCompensation'
import CompensationVM from '../CompensationVM'

export function BZRXCompensationBSCStep2({ vm }: { vm: CompensationVM }) {
  return (
    <BZRXCommonCompensation
      vm={vm}
      compensations={vm.airdropStore.lockedBzrxAirdrops}
      chainIdNeeded={137}
    />
  )
}

export default observer(BZRXCompensationBSCStep2)
